import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setCurrentParkId, getCurrentParkId } from "@/lib/apiClient";
import { useAuth } from "@/contexts/AuthContext";

const ParkContext = createContext(null);

export function ParkProvider({ children }) {
  const { user } = useAuth();
  const [parks, setParks] = useState([]);
  const [currentPark, setCurrentPark] = useState(null);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) {
      setParks([]);
      setCurrentPark(null);
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.get("/parks");
      setParks(data);
      // Resolve current park
      const saved = getCurrentParkId();
      const match = data.find((p) => p.id === saved) || data[0] || null;
      setCurrentPark(match);
      setCurrentParkId(match?.id || "");
    } catch {
      setParks([]);
      setCurrentPark(null);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const switchPark = (parkId) => {
    const next = parks.find((p) => p.id === parkId);
    if (!next) return;
    setCurrentPark(next);
    setCurrentParkId(parkId);
  };

  return (
    <ParkContext.Provider value={{ parks, currentPark, switchPark, refresh, loading }}>
      {children}
    </ParkContext.Provider>
  );
}

export const usePark = () => useContext(ParkContext);
